export default {
    init() {
        let $address_form = $('#app-my-account-address-update');
        let $number_form = $('#app-my-account-number-update');

        if ($address_form.length) {
            console.log($address_form);

            let cbx_primary = $('#app-is-primary-address');
            let sel_address_type = $('#app-address-type-id');
            let inp_company_name = $('#app-company-name');
            let inp_address_1 = $('#app-street-address-1');
            let inp_address_2 = $('#app-street-address-2');
            let inp_city = $('#app-city');
            let inp_state = $('#app-state');
            let inp_zip = $('#app-zip');
            let sel_county = $('#app-county-id');
            let app_button = $('#app-button');

            let check_change = function() {
                let clicked = $(this);
                let changed = false;

                console.log(clicked);

                $.each([
                    sel_address_type,
                    inp_company_name,
                    inp_address_1,
                    inp_address_2,
                    inp_city,
                    inp_state,
                    inp_zip,
                    sel_county,
                ], function() {
                    let elem = $(this);

                    console.log(elem);

                    if (elem.val() != elem.data('initial-value')) {
                        elem.addClass('changed');
                        changed = true;
                    } else {
                        elem.removeClass('changed');
                    }
                });

                if (cbx_primary.is(':checked')
                    && cbx_primary.data('initial-value') != 1) {
                    cbx_primary.closest('div').addClass('changed');
                    changed = true;
                } else {
                    cbx_primary.closest('div').removeClass('changed');
                }

                console.log(changed);

                if (changed) {
                    app_button.prop('disabled', false);
                } else {
                    app_button.prop('disabled', true);
                }
            };

            cbx_primary.on('click', check_change);
            sel_address_type.on('change', check_change);
            inp_company_name.on('keyup', check_change);
            inp_address_1.on('keyup', check_change);
            inp_address_2.on('keyup', check_change);
            inp_city.on('keyup', check_change);
            inp_state.on('keyup', check_change);
            inp_zip.on('keyup', check_change);
            sel_county.on('change', check_change);
        }

        if ($number_form.length) {
            console.log($number_form);

            let cbx_primary = $('#app-is-primary-number');
            let sel_number_type = $('#app-number-type-id');
            let inp_number = $('#app-number');
            let inp_ext = $('#app-extension');
            let app_button = $('#app-button');

            let check_change = function() {
                let clicked = $(this);
                let changed = false;

                console.log(clicked);

                $.each([
                    sel_number_type,
                    inp_number,
                    inp_ext,
                ], function() {
                    let elem = $(this);

                    console.log(elem);

                    if (elem.val() != elem.data('initial-value')) {
                        elem.addClass('changed');
                        changed = true;
                    } else {
                        elem.removeClass('changed');
                    }
                });

                if (cbx_primary.is(':checked')
                    && cbx_primary.data('initial-value') != 1) {
                    cbx_primary.closest('div').addClass('changed');
                    changed = true;
                } else {
                    cbx_primary.closest('div').removeClass('changed');
                }

                console.log(changed);

                if (changed) {
                    app_button.prop('disabled', false);
                } else {
                    app_button.prop('disabled', true);
                }
            };

            cbx_primary.on('click', check_change);
            sel_number_type.on('change', check_change);
            inp_number.on('keyup', check_change);
            inp_ext.on('keyup', check_change);
        }
    },
    finalize() {
    },
};
